import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins, Emit } from "vue-property-decorator";
// SYSTEMONE
import BaseMixer from "../../BaseMixer";
import simplebar from "simplebar-vue";
import Switches from "vue-switches";
import { IAssetTypePropertyDTO } from "@/store/models/asset/assetTypeProperty";
let AssetPropertiesUpsertComponent = /** @class */ (() => {
    var _a;
    let AssetPropertiesUpsertComponent = class AssetPropertiesUpsertComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.filteredControlTypesValue = [];
            this.inputs = [
                {
                    value: "",
                },
            ];
            this.showDropDown = false;
            this.allValid = false;
        }
        checkAndSendSave() {
            this.validate("assetPropertiesObserver").then((response) => {
                if (response) {
                    if (this.controlTypeId == "4e4a2dc9-cd88-42f0-bc8f-9e7496fce557") {
                        this.validateInputs().then((response) => {
                            if (response) {
                                this.model.controlDataListValue = [];
                                for (var i = 0; i < this.inputs.length; i++) {
                                    this.model.controlDataListValue.push(this.inputs[i].value);
                                }
                                return this.save();
                            }
                        });
                    }
                    else {
                        return this.save();
                    }
                }
            });
        }
        async validateInputs() {
            const validationPromises = this.inputs.map((input, index) => {
                return this.$refs[`input-${index}`][0].validate();
            });
            try {
                const responses = await Promise.all(validationPromises);
                return responses.every((response) => response.valid);
            }
            catch (error) {
                console.error("Validation error:", error);
                return false;
            }
        }
        created() {
            if (this.isEdit) {
                this.inputs = [];
            }
            for (var i = 0; i < Object.keys(this.model.controlDataListValue).length; i++) {
                let obj = {
                    value: this.model.controlDataListValue[i],
                };
                this.inputs.push(obj);
            }
        }
        add(value) {
            this.validateInputs().then((response) => {
                if (response) {
                    this.inputs.push({ value: "" });
                }
            });
        }
        remove(index) {
            this.inputs.splice(index, 1);
        }
        get controlTypeId() {
            return this.model.controlTypeId;
        }
        save() { }
        cancel() { }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IAssetTypePropertyDTO !== "undefined" && IAssetTypePropertyDTO) === "function" ? _a : Object)
    ], AssetPropertiesUpsertComponent.prototype, "model", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], AssetPropertiesUpsertComponent.prototype, "controltypes", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], AssetPropertiesUpsertComponent.prototype, "datatypes", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], AssetPropertiesUpsertComponent.prototype, "isEdit", void 0);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AssetPropertiesUpsertComponent.prototype, "save", null);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AssetPropertiesUpsertComponent.prototype, "cancel", null);
    AssetPropertiesUpsertComponent = __decorate([
        Component({
            name: "AssetPropertiesUpsertComponent",
            components: {
                Switches,
                simplebar,
            },
        })
    ], AssetPropertiesUpsertComponent);
    return AssetPropertiesUpsertComponent;
})();
export default AssetPropertiesUpsertComponent;
